export default "__VITE_ASSET__CXfpjk1j__"